import React from 'react';
import {cn} from "../../../../lib/utils";
import DooStyleRadioGroup from "../door style/DooStyleRadioGroup";
import OxideStyleRadioGroup from "./OxideStyleRadioGroup";
import DoorColourRadiogroup from "../door-colour/DoorColourRadiogroup";

const OxideRange =  ({ methods, isOpen: { OxideRange } }) => {
    return (
        <div
            className={cn(
                "section grid grid-cols-4 overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: OxideRange.isOpen,
                }
            )}
        >
    {/*<OxideStyleRadioGroup {...methods}  />*/}
            <DoorColourRadiogroup
                {...methods}
                type='oxide'
                view="external"
            />
        </div>
    );
};

export default OxideRange;
